<template>
  <div class="block" style="padding: 0 10%;">
    <div class="container">
      <section class="section mt-6">
        <div class="columns is-desktop has-text-primary">
          <div class="column">
            <img alt="Team" src="../../assets/teams/feyi.png" />
          </div>
          <div class="column is-three-fifths ml-5 pl-5">
            <h3 class="is-size-3 bold-text mt-3 pt-5"><b>Atanda Oluwafeyijimi. O.</b></h3>
            <p class="regular-text has-text-primary mt-5">
              Atanda Oluwafeyijimi. O. is a computer transcriptionist of Erudite Judgments of the Supreme Court (EJSC), a law publication of Legal Jurisprudence Limited. She graduated from the Federal Polytechnic, Offa, Kwara State. She is a native of Ikenne, Ogun State, Nigeria. Feyi is happily married and enjoys reading, cooking and travelling.
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamInfo",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @font-face {
    font-family: "MontBold";
    src: url("../../fonts/Mont/Mont-Bold.otf");
  }

  @font-face {
    font-family: "MontRegular";
    src: url("../../fonts/Mont/Mont-Regular.otf");
  }

  .bold-text {
    font-family: "MontBold";
  }

  .regular-text {
    font-family: "MontRegular";
  }
</style>
